import { render, staticRenderFns } from "./FichaSidebar.vue?vue&type=template&id=4a437243&"
import script from "./FichaSidebar.vue?vue&type=script&lang=js&"
export * from "./FichaSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports